const APOLOGY = "Apologies for the delay.";
const CONTACT_REP =
  "You can also contact a representative between 8 am and 6 pm CT on weekdays at 1-800-591-9378 for assistance with your trial experience.";
const CONTACT_REP_CHECKPOINT =
  "You can also contact a representative between 8 am and 6 pm CT on weekdays at 1-888-873-8909 for assistance with your trial experience.";
const CHECK_EMAIL =
  "Please check your email in the next 24 hours for details about signing in to your trial.";

export const ENTITLEMENT_DELAY_ERROR = {
  errorHeader: "Network Error",
  message: `${APOLOGY} ${CHECK_EMAIL} ${CONTACT_REP}`,
  code: "OP-RK-TO",
};

export const ENTITLEMENT_DELAY_ERROR_CHECKPOINT = {
  errorHeader: "Network Error",
  message: `${APOLOGY} ${CHECK_EMAIL} ${CONTACT_REP_CHECKPOINT}`,
  code: "OP-RK-TO",
};

export const ONEPASS_DOWN_ERROR = {
  errorHeader: "Network Error",
  message: `${APOLOGY} We're experiencing system issues. ${CHECK_EMAIL} ${CONTACT_REP}`,
  code: "NC-OT",
};

export const NETWORK_ERROR = {
  errorHeader: "Network error",
  message: "Something went wrong. Try refreshing your page.",
  code: "",
};

export const VERIFY_RECAPTCHA_FAILURE = {
  errorHeader: "reCaptcha verification failure",
  message: "User was not verified by reCaptcha",
  code: "recaptcha",
};

export const SOMETHING_WENT_WRONG_ERROR = {
  errorHeader: "Something's wrong",
  message:
    "An error occurred and we couldn't finish setting up your trial at this time. A sales representative will contact you to provide assistance, but feel free to call customer support at 1-800-591-9378 (8 am - 6 pm CT weekdays).",
};

export const INVALID_TOKEN_ERROR = {
  ...SOMETHING_WENT_WRONG_ERROR,
  code: "TokenInvalid",
};

export const NO_ENTITLEMENT_RESPONSE_ERROR = {
  ...SOMETHING_WENT_WRONG_ERROR,
  code: "NoEntitlementResponse",
};
